import React from 'react'
import './Footer.css'
const Footer = () => {
    
  return (
    <div className="footer">
        <p className='small-text'>© 2025 Oriental Daily Sdn Bhd (200201013064). All Rights Reserved.</p>
        <p></p>
    </div>
  )
}

export default Footer